<app-hero title="{{ 'title' | translate }}"
    imageUrl="assets/images/warranty/garantia-banner.png" [imageSettings]="{width: 750, height: 750}"></app-hero>

<div class="rs-wrapper-v4 default-space-between-components">
    <h3>{{'warranty_options_cards_subtitle' | translate}}</h3>
    <div class="help-options-container">
        <app-help-options [notRedirect]="notRedirect" *ngFor="let item of warrantyOptionsModelCard"
            [elementsHelpOptions]="item"></app-help-options>
    </div>
</div>

<ng-container>
    <app-info-block [titleBlock]="'warranty_other_title' | translate"
        [content]="'warranty_other_info_text' | translate" [imageUrl]="'/assets/images/warranty/garantia-soporte.png'"
        title="{{ 'warranty_other_title' | translate }}">
    </app-info-block>
</ng-container>

<app-flyer-saldo backgroundImage="../../assets/landing-social-proof/flyer1.svg">
    <div class="container-flyer centered-div">
        <h2 class="rs-wrapper-v4" [innerHTML]="'warranty_warning' | translate"></h2>
    </div>
</app-flyer-saldo>

<app-info-block [titleBlock]="'convince_user_title' | translate" [content]="'convince_user_info_text' | translate"
    imageUrl="/assets/images/warranty/garantia-conocenos.png" title="{{ 'convince_user_title' | translate }}">
    <p><a [title]="'convince_user_info_link' | translate" (click)="goToDefinition()" class="rs-link">{{ 'convince_user_info_link' |
        translate }}</a></p>
</app-info-block>